<template>
    <el-row :gutter="30" class="mw-100">
        <el-col :lg="24" :xs="24">
            <div class="mb-20 d-flex ">
                <el-button type="primary" @click="handleAddDepartment" class="ml-auto">
                    <span class="color-white">
                        add department
                    </span>
                </el-button>
            </div>
            <el-card class="box-card">
                <el-table :data="allDepartments" style="width: 100%">
                    
                    
                    <el-table-column label="title En">
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'en_us').title}}
                        </template>
                    </el-table-column>

              

                    <el-table-column label="title Ar" >
                        <template #default="scope">
                           <div class="">
                               {{$getLocaleData(scope.row.translates,'ar_sa').title}}
                           </div>
                        </template>
                    </el-table-column>
                   
                  
                    
                    <!-- <el-table-column label="Operations" width="100 ">
                        <template #default="scope">
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="edit department"
                                placement="top"
                            >
                                <font-awesome-icon :icon="['fas', 'edit']" style="width:20px" @click="handleEditDepartment(scope.row)" class="cursor-pointer" />
                            </el-tooltip>
                             
                                
                        </template>
                    </el-table-column> -->
                    <el-table-column label="Operations" width="100">
                        <template #default="scope">
                            <el-popconfirm 
                                title="Are you sure to delete this?"
                                @confirm="deleteDepartment(scope.row)"
                            >
                                <template #reference>
                                   <font-awesome-icon :icon="['fas', 'trash']" style="width:20px" class="cursor-pointer color-red" />
                                </template>
                            </el-popconfirm>
                            
                        </template>
                    </el-table-column>
                </el-table>
               
            </el-card>
        </el-col>
    </el-row>
 
</template>
<script>
export default {
    computed:{
        cachedAllDepartments(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.careers?.departments?.list || []
        },
    },
    data(){
        return{
            allDepartments:[],
            isAddDepartment:false,
           
        }
    },
    mounted(){
        
        if (!this.cachedAllDepartments.length){
            this.getAllDepartments();
        }else{
           
            this.allDepartments = this.cachedAllDepartments;
        }
    },
    
    methods:{
       
        async getAllDepartments(){
            
            const response = await this.$store.dispatch('getAllDepartments');
          
            this.allDepartments = response.data;
            
            
        },
    
        async deleteDepartment(departmentData){
            
            let dataToSend = {
                id:departmentData.id
            }
            const response = await this.$store.dispatch('deleteDepartment',dataToSend);
            if (response.data.status == 1){
                this.getAllDepartments();
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                })
            }
            
        },
       
        async handleAddDepartment(){
            this.$router.push({
                name:'manage-department',
            })
           
        },
        async handleEditDepartment(department){
            await this.$store.dispatch('storeCurrentDepartmentToView',department)
            this.$router.push({
                name:'manage-department',
                params:{
                    id:department.id
                }
            })
        }
    }
}
</script>